import { Menu, X } from 'lucide-react'
import { useEffect, useState } from 'react'

const links = [
  ['system', '系统'],
  ['pressure', '原理'],
  ['exploded', '拆解'],
  ['explore', '探索'],
]

export function BrandMark() {
  return (
    <a className="brand-mark" href="#hero" aria-label="MoLiKa 9bar 首页">
      <span className="brand-mark__name">MoLiKa</span>
      <span className="brand-mark__pressure">9bar</span>
    </a>
  )
}

export default function SiteHeader({ theme }) {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    const close = () => setOpen(false)
    window.addEventListener('resize', close)
    return () => window.removeEventListener('resize', close)
  }, [])

  return (
    <header className={`site-header site-header--${theme}`}>
      <BrandMark />
      <nav className="site-header__desktop-nav" aria-label="主要导航">
        {links.map(([id, label]) => (
          <a href={`#${id}`} key={id}>
            {label}
          </a>
        ))}
      </nav>
      <button
        className="icon-button site-header__menu-button"
        type="button"
        aria-label={open ? '关闭导航' : '打开导航'}
        aria-expanded={open}
        onClick={() => setOpen((value) => !value)}
      >
        {open ? <X aria-hidden="true" /> : <Menu aria-hidden="true" />}
      </button>
      <div className={`mobile-menu ${open ? 'mobile-menu--open' : ''}`} aria-hidden={!open}>
        {links.map(([id, label], index) => (
          <a href={`#${id}`} key={id} onClick={() => setOpen(false)}>
            <span>{String(index + 1).padStart(2, '0')}</span>
            {label}
          </a>
        ))}
      </div>
    </header>
  )
}
